window.LIVTAB_PRODUCTS = [
  {
    id:'cyberone-modular', name:'CyberOne Modular', series:'Smart Modular Workspace', family:'CyberOne Modular', size:'Modular',
    dimensions:'Main Desk: 63.0″ × 31.5″<br>L-Shape: 86.6″ × 63.0″<br>Extended L: 86.6″ × 126.0″<br>U-Shape: 110.2″ × 63.0″', layouts:'Main / L / Extended L / U', motors:'2 / 3 / 4 motors', load:'Main: 300 lb<br>L Shape: 365 lb<br>Extended L: 475 lb<br>U Shape: 475 lb', staticLoad:'Main: 600 lb<br>L Shape: 725 lb<br>Extended L: 950 lb<br>U Shape: 950 lb',
    height:'30.3–44.9 in', speed:'35–40 mm/s', modular:true, smart:'Optional smart modules + app control',
    electronics:'Optional: Pop-up speakers / wireless charging stand / hot & cold cup holder / USB hub / control panel / RGB lighting',
    power:'Integrated power distribution', storage:'Pegboard / PC holder / toolbox / monitor system',
    best:'Expandable smart workspace for advanced setups', delivery:'3–10 business days', warranty:'Up to 10 Years',
    price:'From $999', image:'https://cdn.shopify.com/s/files/1/0605/6263/7044/files/l_baa08a75-eb9f-4ff3-8ae0-17bf81e11acb.png?v=1787222322',
    url:'https://livtab.com/products/cyberone-modular-smart-standing-desk',
    learnMore:'https://livtab.com/pages/cyberone-modular',
    desc:'A smart modular sit-to-stand workstation with flexible layouts, integrated power and optional smart features.'
  },
  {
    id:'creatorone-modular', name:'CreatorOne Modular', series:'Heavy-Duty Modular Workstation', family:'CreatorOne Modular', size:'Modular',
    dimensions:'Main Desk: 63.0″ × 31.5″<br>L-Shape: 86.6″ × 63.0″<br>Extended L: 86.6″ × 126.0″<br>U-Shape: 110.2″ × 63.0″', layouts:'Main / L / Extended L / U', motors:'2 / 3 / 4 motors', load:'Main: 315 lb<br>L Shape: 380 lb<br>Extended L: 500 lb<br>U Shape: 500 lb', staticLoad:'Main: 630 lb<br>L Shape: 760 lb<br>Extended L: 1000 lb<br>U Shape: 1000 lb',
    height:'30.3–47.2 in', speed:'35–40 mm/s', modular:true, smart:'Utility-focused modular system',
    electronics:'No smart electronic accessory modules; rear AC outlets only',
    power:'Integrated power distribution', storage:'Pegboard / PC holder / toolbox / monitor system',
    best:'Creators, makers and heavier multi-device setups', delivery:'3–10 business days', warranty:'Up to 10 Years',
    price:'From $699', image:'https://cdn.shopify.com/s/files/1/0605/6263/7044/files/2_8626702d-0cc6-4626-9aef-52c35c0fc634.png?v=1787222829',
    url:'https://livtab.com/products/creatorone-modular-standing-desk',
    learnMore:'https://livtab.com/pages/creatorone',
    desc:'A heavy-duty modular sit-to-stand workstation with flexible layouts, practical expansion and clean structure.'
  },
  {
    id:'cyberone-pro', name:'CyberOne Pro', series:'All-in-One Smart Standing Desk', family:'CyberOne Pro', size:'All-in-One',
    dimensions:'Desktop: 63.0″ × 31.5″', layouts:'Fixed single-desk layout', motors:'2 motors', load:'300 lb', staticLoad:'600 lb',
    height:'29.1–44.9 in', speed:'35–40 mm/s', modular:false, smart:'Smart functions integrated as standard',
    electronics:'Integrated: Pop-up speakers / wireless charging stand / hot & cold cup holder / USB hub / control panel / RGB lighting',
    power:'Integrated power core + charging', storage:'Pegboard / PC holder / toolbox / built-in drawer',
    best:'A complete smart workstation with everything built in', delivery:'3–10 business days', warranty:'Up to 10 Years',
    price:'$1,599', image:'https://livtab.com/cdn/shop/files/ac31697ecfc979ead7f810fdae063d4d.png?v=1754534803&width=1500',
    url:'https://livtab.com/products/cyberone-pro-smart-standing-desk',
    learnMore:'https://livtab.com/pages/cyberone-pro',
    desc:'An all-in-one smart standing desk with power, charging, storage and smart workspace functions integrated into one system.'
  }
];

/* =========================================================
   V25 - INSTANT PRODUCT DATA
   Product cards now use the approved static Shopify CDN images
   and prices already embedded above, so the page renders in its
   final layout immediately with no 6-product fetch/repaint cycle.
   ========================================================= */
window.LIVTAB_STORE_ORIGIN =
  location.hostname === 'livtab.com' || location.hostname.endsWith('.livtab.com')
    ? location.origin
    : 'https://livtab.com';

/* Compatibility handle for any later code that expects this name.
   It resolves immediately and does not trigger network requests. */
window.LIVTAB_LIVE_DATA_PROMISE = Promise.resolve(window.LIVTAB_PRODUCTS);

const products=window.LIVTAB_PRODUCTS;
const desktopSelections=['cyberone-modular','creatorone-modular','cyberone-pro'];
const requestedCompare=new URLSearchParams(location.search).get('compare')?.split(',').filter(id=>products.some(p=>p.id===id));
let mobileSelections=requestedCompare?.length>=2?requestedCompare.slice(0,2):desktopSelections.slice(0,2);
const compareMedia=window.matchMedia('(max-width:767px)');
const compareProducts=document.querySelector('#compare-products'),stickySelectors=document.querySelector('#sticky-compare-selectors'),table=document.querySelector('#compare-table');

function selectorName(p){return p.name.replace(/\s+Smart\b/i,'')}
function mobileOptions(selected,index){
  const blocked=mobileSelections.filter((id,i)=>i!==index);
  return products.map(p=>`<option value="${p.id}" ${p.id===selected?'selected':''} ${blocked.includes(p.id)?'disabled':''}>${selectorName(p)}</option>`).join('');
}
function mark(v){if(v===true)return '<span aria-label="Included">✓</span>';if(v===false)return '<span aria-label="Not included">No</span>';return v}
function compareImageFor(product){return product.image}

function renderCompare(){
  const ids=compareMedia.matches?mobileSelections:desktopSelections;
  const chosen=ids.map(id=>products.find(p=>p.id===id)).filter(Boolean);

  if(compareMedia.matches){
    stickySelectors.innerHTML=chosen.map((p,i)=>`<select data-compare-index="${i}" aria-label="Choose product for comparison column ${i+1}">${mobileOptions(p.id,i)}</select>`).join('');
  }else{
    stickySelectors.innerHTML=chosen.map(p=>`<div class="compare-static-box" aria-label="${selectorName(p)}">${selectorName(p)}</div>`).join('');
  }

  compareProducts.innerHTML=chosen.map(p=>`<article class="compare-card"><div class="compare-card-image"><img src="${compareImageFor(p)}" alt="LIVTAB ${p.name} in Black"></div><strong class="compare-price">${p.price} USD</strong><div class="livtab-compare-actions"><a class="livtab-compare-buy" href="${p.url}" aria-label="Buy ${p.name} now"><span>Buy now</span></a><a class="livtab-compare-learn" href="${p.learnMore || p.url}" aria-label="Learn more about ${p.name}">Learn more</a></div></article>`).join('');

  table.querySelector('thead').innerHTML='';
  const rows=[
    ['Best for','best'],['Desk sizes','dimensions'],['Available layouts','layouts'],['Lift motors','motors'],
    ['Dynamic load','load'],['Static load','staticLoad'],['Height range','height'],['Lift speed','speed'],['Modular expansion','modular'],
    ['Smart system','smart'],['Electronic accessories','electronics'],['Integrated power','power'],['Storage & organization','storage'],['Warranty','warranty']
  ];
  table.querySelector('tbody').innerHTML=rows.map(([label,key])=>`<tr class="spec-label-row"><th colspan="${chosen.length}" scope="rowgroup">${label}</th></tr><tr class="spec-values-row">${chosen.map(p=>`<td class="${p[key]===true?'yes':p[key]===false?'no':''}"><span class="spec-value">${mark(p[key])}</span></td>`).join('')}</tr>`).join('');
}

function changeComparison(e){
  const select=e.target.closest('select[data-compare-index]');
  if(!compareMedia.matches||!select||!stickySelectors.contains(select))return;
  const index=Number(select.dataset.compareIndex);
  const next=select.value;
  if(mobileSelections.some((id,i)=>i!==index&&id===next))return;
  mobileSelections[index]=next;
  renderCompare();
}

stickySelectors.addEventListener('change',changeComparison);

document.addEventListener('click',e=>{
  const b=e.target.closest('[data-add-compare]');
  if(b){
    const id=b.dataset.addCompare;
    if(compareMedia.matches&&!mobileSelections.includes(id)){
      const keep=mobileSelections.find(existing=>existing!==id) || desktopSelections.find(existing=>existing!==id);
      mobileSelections=[id,keep];
      renderCompare();
    }
    document.querySelector('#compare').scrollIntoView({behavior:'smooth'});
  }
  const set=e.target.closest('[data-compare-set]');
  if(set&&compareMedia.matches){
    const next=set.dataset.compareSet.split(',').filter(id=>products.some(p=>p.id===id)).slice(0,2);
    if(next.length===2&&next[0]!==next[1]){
      mobileSelections=next;
      renderCompare();
    }
  }
});

if(compareMedia.addEventListener){
  compareMedia.addEventListener('change',renderCompare);
}else if(compareMedia.addListener){
  compareMedia.addListener(renderCompare);
}
renderCompare();

document.querySelectorAll('[data-carousel]').forEach(carousel=>{
  const viewport=carousel.querySelector('[data-carousel-viewport]');
  const prev=carousel.querySelector('[data-carousel-prev]');
  const next=carousel.querySelector('[data-carousel-next]');
  const step=()=>{const slide=viewport.querySelector('.carousel-slide');return slide?slide.getBoundingClientRect().width+parseFloat(getComputedStyle(slide.parentElement).gap||0):viewport.clientWidth};
  const slides=[...viewport.querySelectorAll('.carousel-slide')];
  const current=carousel.querySelector('[data-carousel-current]');
  const total=carousel.querySelector('[data-carousel-total]');
  const updateCounter=()=>{if(!current)return;const unit=step();current.textContent=String(Math.min(slides.length,Math.max(1,Math.round(viewport.scrollLeft/unit)+1)));if(total)total.textContent=String(slides.length)};
  prev?.addEventListener('click',()=>viewport.scrollBy({left:-step(),behavior:'smooth'}));
  next?.addEventListener('click',()=>viewport.scrollBy({left:step(),behavior:'smooth'}));
  viewport.addEventListener('scroll',()=>requestAnimationFrame(updateCounter),{passive:true});
  updateCounter();
});


/* Secretlab-inspired scene gallery - fixed copy, image switching only */
document.querySelectorAll('[data-scene-gallery]').forEach(gallery=>{
  const mainImage=gallery.querySelector('[data-scene-main-image]');
  const current=gallery.querySelector('[data-scene-current]');
  const total=gallery.querySelector('[data-scene-total]');
  const thumbs=[...gallery.querySelectorAll('[data-scene-index]')];
  const thumbsViewport=gallery.querySelector('[data-scene-thumbs]');
  let active=0;

  if(total) total.textContent=String(thumbs.length);

  function showScene(index,scrollThumb=true){
    active=(index+thumbs.length)%thumbs.length;
    const thumb=thumbs[active];
    if(!thumb) return;

    mainImage.classList.add('is-changing');

    window.setTimeout(()=>{
      mainImage.src=thumb.dataset.image;
      mainImage.alt=thumb.dataset.alt || '';
      if(current) current.textContent=String(active+1);
      thumbs.forEach((item,i)=>item.classList.toggle('is-active',i===active));
      mainImage.classList.remove('is-changing');

      if(scrollThumb){
        const left=thumb.offsetLeft-(thumbsViewport.clientWidth-thumb.clientWidth)/2;
        thumbsViewport.scrollTo({left:Math.max(0,left),behavior:'smooth'});
      }
    },120);
  }

  thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showScene(index,false)));
  gallery.querySelector('[data-scene-prev]')?.addEventListener('click',()=>showScene(active-1));
  gallery.querySelector('[data-scene-next]')?.addEventListener('click',()=>showScene(active+1));
});


const reviews=[
  {name:'Brandon Foster',product:'CyberOne Modular',title:'Worth it for my setup',body:'He liked not having to solve power distribution and cable management separately, which made the finished setup much easier to organize.'},
  {name:'Emily Carter',product:'CyberOne Modular',title:'More useful than expected',body:'The charging station and pegboard became everyday features, while the optional smart modules added convenience during longer desk sessions.'},
  {name:'Trevor Hayes',product:'CyberOne Modular',title:'A great U-shaped setup',body:'After planning the cable routing, the larger modular layout felt solid with a PC and three monitors and worked well for both daytime use and gaming.'},
  {name:'Natalie Brooks',product:'CyberOne Modular',title:'Finally got the cables off the floor',body:'She liked how the system fit together and how much cleaner the completed setup looked once the cabling was organized.'},
  {name:'Hannah Collins',product:'CreatorOne Modular',title:'Good shared work table',body:'The height adjustment worked well for two different users, and the frame remained stable at standing height with plenty of monitor depth.'},
  {name:'Marcus Reed',product:'CreatorOne Modular',title:'Clean and simple',body:'He wanted a desk that did not look overly gaming-focused and liked the clean appearance, two-monitor space and mostly hidden cables.'},
  {name:'Olivia Bennett',product:'CreatorOne Modular',title:'Great desk, bring a second person',body:'The finished desk felt solid and the lift controls worked immediately. She also liked being able to start with a straight desk and expand later.'},
  {name:'Ethan Parker',product:'CreatorOne Modular',title:'My office finally feels finished',body:'He liked the smooth lift, stable typing experience and the way the desk made the whole office feel more complete.'},
  {name:'Ethan Ross',product:'CyberOne Pro',title:'Great desk',body:'He was impressed by the build quality and said the desk felt sturdy and better finished than expected.'},
  {name:'Nicole Harper',product:'CyberOne Pro',title:'A big upgrade from my old desk',body:'She found the lift smooth and the desk stable, with cable management taking some initial setup before the workspace felt dialed in.'}
];
function reviewCard(r){return `<article class="review-card"><div class="review-stars" aria-label="5 out of 5 stars">★★★★★</div><h3>${r.title}</h3><p>${r.body}</p><footer><strong>${r.name}</strong><span>${r.product}</span></footer></article>`}
document.querySelectorAll('[data-review-track]').forEach((track,index)=>{const source=index?reviews.slice().reverse():reviews;const html=source.map(reviewCard).join('');track.innerHTML=html+html});

(function(){
  const root = document.documentElement;
  const compare = document.querySelector('.sticky-compare-selectors');
  if(!compare) return;

  function visible(el){
    const s = getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return s.display !== 'none' &&
           s.visibility !== 'hidden' &&
           r.width > 0 &&
           r.height > 0;
  }

  function updateHeaderOffset(){
    const selectors = [
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      '.header-wrapper',
      '.header-group',
      '.site-header',
      'header'
    ];

    const seen = new Set();
    let bottom = 0;

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if(seen.has(el) || el.contains(compare) || !visible(el)) return;
        seen.add(el);

        const style = getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        const stickyLike = style.position === 'sticky' || style.position === 'fixed';

        /* Count only navigation/header elements currently occupying the viewport top. */
        if(stickyLike && rect.top <= 6 && rect.bottom > 0){
          bottom = Math.max(bottom, rect.bottom);
        }
      });
    });

    /* Safe fallback for themes whose header wrapper does not expose a common selector. */
    if(bottom <= 0){
      bottom = window.innerWidth <= 767 ? 60 : 72;
    }

    root.style.setProperty('--livtab-store-header-offset', Math.ceil(bottom) + 'px');
  }

  updateHeaderOffset();

  let ticking = false;
  function schedule(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateHeaderOffset();
      ticking = false;
    });
  }

  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('scroll', schedule, {passive:true});

  if('ResizeObserver' in window){
    const ro = new ResizeObserver(schedule);
    document.querySelectorAll(
      '#shopify-section-header,.shopify-section-group-header-group,.header-wrapper,.header-group,.site-header,header'
    ).forEach(el => ro.observe(el));
  }
})();

(function(){
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-selling-point]'));
  if(!cards.length) return;

  var modal = document.createElement('div');
  modal.className = 'livtab-selling-modal';
  modal.setAttribute('aria-hidden','true');
  modal.innerHTML =
    '<div class="livtab-selling-modal__backdrop" data-selling-close></div>' +
    '<div class="livtab-selling-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="livtab-selling-modal-title">' +
      '<div class="livtab-selling-modal__header">' +
        '<h3 class="livtab-selling-modal__title" id="livtab-selling-modal-title" data-selling-title></h3>' +
        '<button class="livtab-selling-modal__close" type="button" aria-label="Close" data-selling-close>×</button>' +
      '</div>' +
      '<div class="livtab-selling-modal__image">' +
        '<img data-selling-image alt="">' +
      '</div>' +
      '<p class="livtab-selling-modal__description" data-selling-description></p>' +
      '<div class="livtab-selling-modal__controls" aria-label="Switch selling point">' +
        '<button class="livtab-selling-modal__nav" type="button" aria-label="Previous selling point" data-selling-prev>‹</button>' +
        '<span class="livtab-selling-modal__counter" data-selling-counter>1 / 3</span>' +
        '<button class="livtab-selling-modal__nav" type="button" aria-label="Next selling point" data-selling-next>›</button>' +
      '</div>' +
    '</div>';

  document.body.appendChild(modal);

  var closeButton = modal.querySelector('.livtab-selling-modal__close');
  var image = modal.querySelector('[data-selling-image]');
  var counter = modal.querySelector('[data-selling-counter]');
  var currentIndex = 0;
  var lastTrigger = null;

  function renderCard(index){
    currentIndex = (index + cards.length) % cards.length;
    var card = cards[currentIndex];

    modal.querySelector('[data-selling-title]').textContent = card.dataset.title || '';
    modal.querySelector('[data-selling-description]').textContent = card.dataset.description || '';
    image.src = card.dataset.image || '';
    image.alt = card.dataset.alt || '';
    counter.textContent = (currentIndex + 1) + ' / ' + cards.length;
  }

  function openModal(card){
    lastTrigger = card;
    currentIndex = cards.indexOf(card);
    if(currentIndex < 0) currentIndex = 0;
    renderCard(currentIndex);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('livtab-modal-open');
    window.setTimeout(function(){ closeButton.focus(); },0);
  }

  function closeModal(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('livtab-modal-open');
    image.removeAttribute('src');
    if(lastTrigger) lastTrigger.focus();
  }

  cards.forEach(function(card){
    card.addEventListener('click',function(){ openModal(card); });
    card.addEventListener('keydown',function(event){
      if(event.key === 'Enter' || event.key === ' '){
        event.preventDefault();
        openModal(card);
      }
    });
  });

  modal.querySelector('[data-selling-prev]').addEventListener('click',function(event){
    event.stopPropagation();
    renderCard(currentIndex - 1);
  });

  modal.querySelector('[data-selling-next]').addEventListener('click',function(event){
    event.stopPropagation();
    renderCard(currentIndex + 1);
  });

  modal.addEventListener('click',function(event){
    if(event.target.closest('[data-selling-close]')) closeModal();
  });

  document.addEventListener('keydown',function(event){
    if(!modal.classList.contains('is-open')) return;

    if(event.key === 'Escape'){
      closeModal();
    }else if(event.key === 'ArrowLeft'){
      event.preventDefault();
      renderCard(currentIndex - 1);
    }else if(event.key === 'ArrowRight'){
      event.preventDefault();
      renderCard(currentIndex + 1);
    }
  });
})();